export enum ROLES_NAME {
  MANAGER = "admin-co",
  SUBMANAGER = "admin-co-sub",
  COLLABORATOR = "collaborator",
  ADMIN = "admin",
  ADMINCW = "admin-cw",
}

export enum ROLES_BY_ROLES {
  "admin" = "manager",
  "admin-co" = "manager",
  "admin-co-sub" = "submanager",
  "admin-cw" = "collaborator",
  "collaborator" = "collaborator",
  "" = "collaborator",
}
